import { useTranslation } from "@msuite/ui/localization";
import { OverflowList } from "@msuite/ui/overflow-list";
import { Popover } from "@msuite/ui/popover";
import { Tag } from "@msuite/ui/tag";
import type { IncomingEmailAttachmentListItem } from "@msuite/utils/types";
import { IncomingEmailAttachmentLink } from "./incoming-email-attachment-link";

/** Props Interface */
interface IncomingEmailAttachmentsProps {
	attachments: Array<IncomingEmailAttachmentListItem>;
}

export function IncomingEmailAttachments({ attachments }: IncomingEmailAttachmentsProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!attachments.length) return <span className="label">{t("mailboxes.no_attachments")}</span>;

	/** Render */
	// The cell stays one line tall whatever the count: the links that fit are shown, the rest fold
	// into a "+ n" tag whose popover lists them — the same shape the project managers column keeps.
	return (
		<div className="absolute inset-y-0 inset-x-2 h-stack items-center">
			<OverflowList
				items={attachments}
				renderItem={(attachment) => <IncomingEmailAttachmentLink attachment={attachment} />}
				renderOverflowItem={({ overflowCount, hiddenItems }) => (
					<Popover
						trigger="hover"
						render={() => (
							<div className="v-stack items-start">
								{hiddenItems.map((attachment) => (
									<IncomingEmailAttachmentLink
										key={attachment.id}
										attachment={attachment}
									/>
								))}
							</div>
						)}
					>
						<Tag
							size="xs"
							color="gray"
							withStatusIndicator={false}
						>
							+ {overflowCount}
						</Tag>
					</Popover>
				)}
			/>
		</div>
	);
}
